import React, { useId } from 'react';
import { motion } from 'framer-motion';
import { copy } from '../data/copy';
import { useLanguage, type Lang } from '../contexts/LanguageContext';
const LANGS: Lang[] = ['es', 'en'];
const ease = [0.23, 1, 0.32, 1] as const;
type LanguageToggleProps = {
  /** 'compact' shows ES / EN, 'full' shows the native language names. */
  size?: 'compact' | 'full';
  className?: string;
};
export function LanguageToggle({
  size = 'compact',
  className = ''
}: LanguageToggleProps) {
  const {
    lang,
    setLang,
    t
  } = useLanguage();
  const layoutId = `lang-pill-${useId()}`;
  const isFull = size === 'full';
  return <div role="group" aria-label={t.a11y.languageSwitcher} className={`items-center gap-1 rounded-full border border-gold-deep/50 bg-gold-deep/10 p-1 ${isFull ? 'flex w-full' : 'inline-flex'} ${className}`} data-id="element-231" data-mp="2f90t8x6ug6l1">
      {LANGS.map(code => {
      const active = code === lang;
      return <button key={code} type="button" onClick={() => setLang(code)} aria-pressed={active} aria-label={copy[code].a11y.switchTo} lang={code} className={`relative rounded-full font-semibold uppercase tracking-[0.16em] transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-soft focus-visible:ring-offset-2 focus-visible:ring-offset-black ${isFull ? 'flex-1 px-5 py-3 text-[12px]' : 'px-3 py-1.5 text-[11px]'} ${active ? 'text-ink-900' : 'text-neutral-400 hover:text-gold-soft'}`} data-id="element-232" data-mp="1ht4spoy331me">
            {active ? <motion.span layoutId={layoutId} aria-hidden="true" transition={{
          duration: 0.22,
          ease
        }} className="absolute inset-0 rounded-full bg-gold-soft" data-id="element-233" data-mp="o0izewxmj285" /> : null}
            <span className="relative whitespace-nowrap" data-id="element-234" data-mp="xvayy6arnz5k">
              {isFull ? copy[code].nativeName : code.toUpperCase()}
            </span>
          </button>;
    })}
    </div>;
}